import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'AdminUsersRole',
    column_type: 'id',
    label_key_path: 'adminUsersRole.id',
  },
  created_at: {
    model_name: 'AdminUsersRole',
    column_type: 'datetime',
    label_key_path: 'adminUsersRole.createdAt',
  },
  updated_at: {
    model_name: 'AdminUsersRole',
    column_type: 'datetime',
    label_key_path: 'adminUsersRole.updatedAt',
  },
  role: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    label_key_path: 'adminUsersRole.role',
    extra: {
      association_name: 'role',
      model_name: 'Role',
      foreign_key: 'role_id',
      display_column: 'name',
    },
  },
  role_id: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    label_key_path: 'adminUsersRole.role',
    extra: {
      association_name: 'role',
      model_name: 'Role',
      foreign_key: 'role_id',
      display_column: 'name',
    },
  },
  admin_user: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    label_key_path: 'adminUsersRole.adminUser',
    extra: {
      association_name: 'admin_user',
      model_name: 'AdminUser',
      foreign_key: 'admin_user_id',
      display_column: 'name',
    },
  },
  admin_user_id: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    label_key_path: 'adminUsersRole.adminUser',
    extra: {
      association_name: 'admin_user',
      model_name: 'AdminUser',
      foreign_key: 'admin_user_id',
      display_column: 'name',
    },
  },
  application: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    label_key_path: 'adminUsersRole.application',
    extra: {
      association_name: 'application',
      model_name: 'Application',
      foreign_key: 'application_id',
      display_column: 'name',
    },
  },
  application_id: {
    model_name: 'AdminUsersRole',
    column_type: 'belongs_to',
    label_key_path: 'adminUsersRole.application',
    extra: {
      association_name: 'application',
      model_name: 'Application',
      foreign_key: 'application_id',
      display_column: 'name',
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
